var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaturation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99844 2.24219L14.7151 6.95885C15.6479 7.89103 16.2833 9.07891 16.5409 10.3722C16.7984 11.6656 16.6667 13.0062 16.1622 14.2247C15.6578 15.4431 14.8033 16.4845 13.7069 17.2173C12.6104 17.95 11.3213 18.3411 10.0026 18.3411C8.68388 18.3411 7.39477 17.95 6.29835 17.2173C5.20193 16.4845 4.34745 15.4431 3.84299 14.2247C3.33854 13.0062 3.20677 11.6656 3.46436 10.3722C3.72195 9.07891 4.35732 7.89103 5.29011 6.95885L9.99844 2.24219Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturation);
export default __webpack_public_path__ + "static/media/Saturation.03d704b7be64c57f5c744f36c5a1b1f1.svg";
export { ForwardRef as ReactComponent };